export default [
  {
    name: 'SEARCH_ITEM',
    value: { XS: 24, sm: 24,md: 12, lg: 6, xl: 4, class: 'mb-12' }
  },
  {
    name: 'SEARCH_ITEM_DOUBLE',
    value: { XS: 24, sm: 24,md: 12, lg: 12, xl: 8 , class: 'mb-12' }
  },
  {
    name: 'DATE_PICKER',
    value: { XS: 24, sm: 24,md: 12, lg: 8, xl: 6, class: 'mb-12' }
  },
  {
    name: 'SEARCH_BUTTON_ITEM',
    value: { XS: 6, sm: 4,md: 4, lg: 4, xl: 2, class: 'mb-12' }
  }
]